<template>
  <div class="page-container">
    <div class="page-header">
      <h1 class="page-title">最新消息</h1>
      <router-link class="btn btn-primary" :to="{ name: 'WebsiteBlogCreate' }">新增文章</router-link>
    </div>

    <div class="page-toolbar">
      <div class="search-box">
        <input v-model="search" type="text" class="form-control" placeholder="搜尋標題／slug…" @input="debouncedFetch" />
        <i class="ri-search-line"></i>
      </div>
      <div class="filter-group">
        <select v-model="status" class="form-control" @change="fetchList">
          <option value="">全部狀態</option>
          <option value="draft">草稿</option>
          <option value="published">已發佈</option>
          <option value="archived">已封存</option>
        </select>
      </div>
      <div class="filter-group">
        <select v-model="category" class="form-control" @change="fetchList">
          <option value="">全部分類</option>
          <option value="product">產品動態</option>
          <option value="guide">使用教學</option>
          <option value="announcement">公告</option>
        </select>
      </div>
    </div>

    <div v-if="loading" class="loading-state"><div class="spinner" /><p>載入中...</p></div>
    <div v-else-if="error" class="error-state">
      <p>{{ error }}</p>
      <button class="btn btn-secondary" @click="fetchList">重試</button>
    </div>
    <div v-else class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>標題</th>
            <th>分類</th>
            <th>狀態</th>
            <th>發佈時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="items.length === 0">
            <td colspan="5" class="empty-state">尚無文章</td>
          </tr>
          <tr v-for="item in items" :key="item.id">
            <td>
              <div class="title-cell">{{ item.title }}</div>
              <code class="slug">/blog/{{ item.slug }}</code>
            </td>
            <td>{{ categoryLabel(item.category) }}</td>
            <td><span class="badge" :class="statusClass(item.status)">{{ statusLabel(item.status) }}</span></td>
            <td>{{ formatDate(item.publishedAt) }}</td>
            <td class="col-actions">
              <router-link class="btn-action" :to="{ name: 'WebsiteBlogEdit', params: { id: item.id } }" title="編輯">
                <i class="ri-edit-line"></i>
              </router-link>
              <button class="btn-action danger" title="刪除" @click="remove(item)">
                <i class="ri-delete-bin-line"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { websiteBlogService } from '@/api/modules/website.js'
import { showSuccess, showError, showConfirm } from '@/utils/swal.js'

export default {
  name: 'WebsiteBlogIndex',
  data() {
    return {
      loading: false,
      error: '',
      search: '',
      status: '',
      category: '',
      items: [],
      debounceTimer: null,
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    categoryLabel(c) {
      return ({ product: '產品動態', guide: '使用教學', announcement: '公告' })[c] || c
    },
    statusLabel(s) {
      return ({ draft: '草稿', published: '已發佈', archived: '已封存' })[s] || s
    },
    statusClass(s) {
      return ({ draft: 'badge-secondary', published: 'badge-success', archived: 'badge-warning' })[s] || ''
    },
    formatDate(v) {
      if (!v) return '—'
      return new Date(v).toLocaleString('zh-TW')
    },
    debouncedFetch() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => this.fetchList(), 300)
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const res = await websiteBlogService.list({
          search: this.search || undefined,
          status: this.status || undefined,
          category: this.category || undefined,
          pageSize: 50,
        })
        this.items = res?.data?.items || []
      } catch (e) {
        this.error = e?.response?.data?.message || '載入失敗'
      } finally {
        this.loading = false
      }
    },
    async remove(item) {
      const ok = await showConfirm('確定刪除？', `將刪除「${item.title}」`)
      if (!ok) return
      try {
        await websiteBlogService.remove(item.id)
        showSuccess('已刪除')
        this.fetchList()
      } catch (e) {
        showError(e?.response?.data?.message || '刪除失敗')
      }
    },
  },
}
</script>

<style scoped>
@import '~@/assets/scss/components/_list-page-common.scss';
.table-wrapper table { min-width: 900px; }
.title-cell { font-weight: 600; }
.slug { font-size: 12px; color: #64748b; }
.col-actions { white-space: nowrap; }
.btn-action { border: none; background: transparent; cursor: pointer; color: #0d9488; font-size: 18px; margin-right: 6px; }
.btn-action.danger { color: #dc2626; }
.badge { padding: 2px 8px; border-radius: 999px; font-size: 12px; }
.badge-success { background: #d1fae5; color: #065f46; }
.badge-secondary { background: #e2e8f0; color: #475569; }
.badge-warning { background: #fef3c7; color: #92400e; }
</style>
